import React from 'react'
import A from '@components/A'
import { nodeLocaleToEnglishLanguage } from '@utils'
import { ProBodyCopy, H3 } from '@components/Globals'
import { useLocale } from '@hooks'

const ProfessionalLinkGroup = ({ title, items, field = 'title' }) => {
  const { locale } = useLocale()
  const localizedItems =
    items &&
    items.length > 0 &&
    items.filter(
      i =>
        !i.displayOnSites ||
        (i.displayOnSites &&
          i.displayOnSites.includes(nodeLocaleToEnglishLanguage[locale]))
    )
  return (
    <>
      {localizedItems && localizedItems.length > 0 && (
        <H3 color="gray" marginBottom={10} className={title.class}>
          {title.name}
        </H3>
      )}
      {localizedItems &&
        localizedItems.length > 0 &&
        localizedItems.map(item =>
          item.slug ? (
            <A to={item?.slug} contentType={item?.__typename} key={item.id}>
              <ProBodyCopy color="gold">{item[field]}</ProBodyCopy>
            </A>
          ) : item.schoolName ? (
            <ProBodyCopy
              key={item.id}
            >{`${item.schoolName}, ${item.degree} ${item.year}`}</ProBodyCopy>
          ) : (
            <ProBodyCopy key={item.id}>{item[field]}</ProBodyCopy>
          )
        )}
      <br />
    </>
  )
}

export default ProfessionalLinkGroup
